/*
  Cactus Corn: Popcorn of the Month Club page (sections/cc-potm.liquid prints the cards, a real /cart/add form,
  and the settings as JSON). Keeps Seal out, keeps the summary and sticky bar in step, works out the first ship
  date as Seal does, runs pick your own, and adds to the cart. Test: CCPOTM_TEST = true; CCPOTM_TODAY = 'YYYY-MM-DD'.
*/
(() => {
'use strict';

const DAY = 86400000;
const html = document.documentElement;
const $ = (sel, el) => (el || document).querySelector(sel);
const $$ = (sel, el) => Array.from((el || document).querySelectorAll(sel));
// Cents to "$30", "$27.50", "$1,200".
const money = c => '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
const fill = (tpl, vars) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (vars[k] != null ? String(vars[k]) : m));
const scrollTo = (x, block) => x && x.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: block || 'center' });
const route = path => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path;
const post = (path, body) => fetch(route(path), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
// "a, b, and c"
const list = a => (a.length < 3 ? a.join(' and ') : a.slice(0, -1).join(', ') + ', and ' + a[a.length - 1]);

/* Dates: a UTC midnight stands for a Phoenix calendar day */
const parseISO = s => { const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || '').trim()); return m ? new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])) : null; };
const iso = d => d.toISOString().slice(0, 10);
const addDays = (d, n) => new Date(d.getTime() + n * DAY);
const addMonths = (d, n) => new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + n, d.getUTCDate()));
// "Mon, Nov 16", or with y "Mon, Nov 15, 2027".
const fmtDay = (d, y) => d.toLocaleDateString('en-US', Object.assign({ timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }, y ? { year: 'numeric' } : {}));
const fmtShort = d => fmtDay(d).replace(/^\w+, /, '');
const phxToday = () => {
  const p = {};
  new Intl.DateTimeFormat('en-US', { timeZone: 'America/Phoenix', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date()).forEach(x => { p[x.type] = +x.value; });
  return new Date(Date.UTC(p.year, p.month - 1, p.day));
};
// US postal holidays as observed (Saturday ones on Friday, Sunday ones on Monday).
const holidayCache = {};
function holidays(y) {
  if (holidayCache[y]) return holidayCache[y];
  const out = new Set();
  const nth = (m, wd, n) => { const f = new Date(Date.UTC(y, m, 1)); return new Date(Date.UTC(y, m, 1 + (wd - f.getUTCDay() + 7) % 7 + 7 * (n - 1))); };
  const last = (m, wd) => { const end = new Date(Date.UTC(y, m + 1, 0)); return addDays(end, -((end.getUTCDay() - wd + 7) % 7)); };
  const observed = d => { const w = d.getUTCDay(); return w === 6 ? addDays(d, -1) : w === 0 ? addDays(d, 1) : d; };
  // New Year's, Juneteenth, July 4, Veterans Day, Christmas; then MLK, Presidents', Memorial, Labor, Columbus, Thanksgiving.
  [[0, 1], [5, 19], [6, 4], [10, 11], [11, 25]].forEach(([m, d]) => out.add(iso(observed(new Date(Date.UTC(y, m, d))))));
  if (new Date(Date.UTC(y + 1, 0, 1)).getUTCDay() === 6) out.add(y + '-12-31');
  [nth(0, 1, 3), nth(1, 1, 3), last(4, 1), nth(8, 1, 1), nth(9, 1, 2), nth(10, 4, 4)].forEach(d => out.add(iso(d)));
  return (holidayCache[y] = out);
}

/* Boot, and again when the theme editor reloads the section. If init throws, its listeners come off and the page
   falls back to the no-JavaScript form (every plan's terms, a plain Add to cart that posts the form). */
const roots = scope => $$('[data-ccpotm]', scope && scope.querySelectorAll ? scope : document);
const boot = scope => roots(scope).forEach(root => {
  if (root.ccpotm) return;
  const offs = [];
  try { root.ccpotm = init(root, offs); } catch (err) {
    offs.forEach(off => off());
    html.classList.remove('ccpotm-js');
    console.error('[ccpotm]', err);
  }
});
const unboot = scope => roots(scope).forEach(root => { if (root.ccpotm) { root.ccpotm.destroy(); root.ccpotm = null; } });
window.CCPOTM = { boot, unboot };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
document.addEventListener('shopify:section:load', e => boot(e.target));
document.addEventListener('shopify:section:unload', e => unboot(e.target));

function init(root, offs) {
  const cfg = JSON.parse($('[data-ccpotm-config]', root).textContent);
  const T = cfg.t;
  const el = name => $('[data-' + name + ']', root);
  const form = el('ccpotm-form');
  const addBtn = el('add');
  const quiet = !!(cfg.test || cfg.design); // no analytics in test mode or the editor
  const on = (target, type, fn, opts) => { if (!target) return; target.addEventListener(type, fn, opts); offs.push(() => target.removeEventListener(type, fn, opts)); };
  const watch = (target, fn, opts) => { const mo = new MutationObserver(fn); mo.observe(target, opts); offs.push(() => mo.disconnect()); };

  /* Seal, layer 2 of 3 (1: the kill switch in the section; 3: the CSS). The form's action comes off at the end. */
  let sealHits = 0;
  const sealGuard = () => $$('.sealsubs-container, .sls-purchase-options-container, [data-sls-selling_plan], input[type="hidden"][name="selling_plan"]', root).forEach(x => {
    if (sealHits++ > 50) return; // don't fight a loop forever; the CSS still hides it
    console.info('[ccpotm] removed a Seal element', x);
    x.remove();
  });
  sealGuard();
  watch(root, sealGuard, { childList: true, subtree: true });

  /* Data and state */
  const variants = new Map(cfg.variants.map(v => [v.id, v]));
  const packs = cfg.packs || [];
  const byoPack = packs.find(p => p.byo) || null;
  const flavorBy = new Map((cfg.flavors || []).map(f => [f.name.toLowerCase(), f]));
  const checked = name => { const r = $(`input[name="${name}"]:checked`, form); return r ? r.value : ''; };
  const field = f => $(`[data-field="${f}"]`, form);
  const val = f => { const x = field(f); return x ? x.value.replace(/[ \t]+/g, ' ').replace(/\n{3,}/g, '\n\n').trim() : ''; };
  const state = { variant: +checked('id'), plan: +checked('selling_plan') || 0, who: checked('ccpotm_who') === 'gift' ? 'gift' : 'me', picks: [], planPicked: false, giftSet: false };

  const pack = () => packs.find(p => p.variant === state.variant) || null;
  const lineup0 = (packs.find(p => !p.byo && (variants.get(p.variant) || {}).available) || packs.find(p => !p.byo) || {}).variant;
  if (!pack()) state.variant = lineup0;
  let lastLineup = pack() && !pack().byo ? state.variant : lineup0;
  const slotsOf = pk => (pk && pk.byo ? pk.slots || 3 : 0);
  const info = a => ({ id: a.plan, price: a.price, compare: Math.max(a.compare || 0, a.price), per: a.per, renew: a.renew || a.price, boxes: Math.max(1, Math.round(a.price / a.per)) });
  const plansFor = vid => ((variants.get(vid) || {}).allocs || []).filter(a => a.per > 0).map(info).sort((x, y) => x.boxes - y.boxes);
  const plan = () => plansFor(state.variant).find(p => p.id === state.plan) || null;
  const planByBoxes = n => plansFor(state.variant).find(p => p.boxes === n) || null;
  const planKey = p => (p.boxes === 1 ? 'monthly' : String(p.boxes));
  const byoDone = () => { const pk = pack(); return !pk || !pk.byo || state.picks.length === slotsOf(pk); };

  /* Words: the same templates (section settings) the Liquid printed */
  const ends = p => p.boxes > 1 && cfg.afterTerm === 'ends';
  const planLabel = p => (p.boxes === 1 ? T.planMonthly : fill(T.planPrepaid, { n: p.boxes }));
  const afterText = p => (cfg.afterTerm === 'ends' ? fill(T.ends, { n: p.boxes }) : fill(T.renews, { price: money(p.renew), n: p.boxes }));
  // k 'terms': the terms line; k 'gift': the gift's billing line. Monthly, paid ahead that ends, or that renews.
  const terms = (p, k) => fill(T[k + (p.boxes === 1 ? 'Monthly' : ends(p) ? 'Ends' : 'Renews')], { price: money(p.boxes === 1 ? p.renew : p.price), n: p.boxes, renew: money(p.renew), ship_day: T.shipDay });
  const sumPlan = p => (p.boxes === 1 ? fill(T.sumMonthly, { price: money(p.per) }) : fill(T.sumPrepaid, { n: p.boxes, price: money(p.per) }));
  const picksText = () => state.picks.filter((f, i) => state.picks.indexOf(f) === i)
    .map(f => { const n = state.picks.filter(x => x === f).length; return n > 1 ? `${f} (${n})` : f; }).join(', ');

  /* First box, as Seal schedules it */
  const D = cfg.dates || {};
  const dd = {
    shipDay: Math.min(28, Math.max(1, +D.shipDay || 15)), lastOrder: parseISO(D.lastOrder), noteFrom: parseISO(D.noteFrom),
    cutoffAt: Date.parse(D.lastOrderUntil || '') || 0,
    from: parseISO(D.noShipFrom), to: parseISO(D.noShipTo), reopen: parseISO(D.reopen),
    closed: new Set(String(D.closed || '').split(/\s+/).filter(x => parseISO(x)))
  };
  // CCPOTM_TODAY counts only on test pages or in test mode.
  const today = () => ((cfg.test || window.CCPOTM_TEST === true) && parseISO(window.CCPOTM_TODAY)) || phxToday();
  // A date with its weekday, and the year when it isn't this year (a 12-month renewal is the same day next year).
  const day = d => fmtDay(d, d.getUTCFullYear() !== today().getUTCFullYear());
  const inBreak = d => !!(dd.from && dd.to && d >= dd.from && d <= dd.to);
  // A box due from the first no-ship day until shipping starts again goes out the week it starts.
  const held = d => !!(dd.from && dd.reopen && d >= dd.from && d < dd.reopen);
  // Past the last order date, or on it after the order-by time (11 AM): the first box waits for the reopen week.
  const late = t => !!(dd.lastOrder && dd.reopen && t < dd.reopen && (t > dd.lastOrder || (+t === +dd.lastOrder && dd.cutoffAt && Date.now() >= dd.cutoffAt)));
  const isShipDay = d => { const w = d.getUTCDay(); return w !== 0 && w !== 6 && !holidays(d.getUTCFullYear()).has(iso(d)) && !dd.closed.has(iso(d)) && !inBreak(d); };
  const nextShipDay = d => { for (let i = 0; i < 60 && !isShipDay(d); i++) d = addDays(d, 1); return d; };
  // The anchor: the next ship day (the 15th) after today; an order on the 15th ships right away.
  const anchorAfter = t => {
    const a = new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), dd.shipDay));
    return a > t ? a : new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() + 1, dd.shipDay));
  };
  // Seal (anchor, ASAP): an order within the plan's cutoff waits for the anchor, even one in the holiday break.
  function firstBox(p) {
    const t = today(), A = anchorAfter(t), cut = Math.max(0, +(p.boxes === 1 ? D.monthlyCutoff : D.prepaidCutoff) || 0);
    const within = Math.round((A - t) / DAY) <= cut;
    // Monthly: the first box ships right away; within Seal's cutoff the next charge moves to the following month.
    const waits = p.boxes === 1 ? false : within;
    const N = p.boxes === 1 && within ? addMonths(A, 1) : A;
    const reopen = dd.reopen ? fmtShort(dd.reopen) : '';
    const out = { lines: [], note: '', prop: '' };
    const line = (tpl, vars, prop) => { out.lines.push(fill(tpl, vars)); if (prop) out.prop = prop; };
    if (waits ? held(A) : late(t)) line(T.firstHoliday, { date: reopen }, 'Ships the week of ' + reopen);
    else if (waits) { const d = day(nextShipDay(A)); line(T.firstDate, { date: d }, 'Ships ' + d); }
    else line(T.firstAsap, { asap: T.asap }, 'Ships ' + T.asap);
    // Monthly, shipping now: Seal charges again on the anchor. Say so, and when that box falls in the break.
    if (p.boxes === 1) {
      out.next = day(N);
      line(T.nextCharge, { price: money(p.renew), date: day(N), ship_day: T.shipDay });
      if (held(N)) line(T.nextBreak, { date: fmtShort(N), reopen });
    }
    // Paid ahead that renews: the first renewal is the anchor after the last paid box.
    if (p.boxes > 1 && !ends(p)) line(T.renewOn, { renew: money(p.renew), n: p.boxes, date: day(addMonths(A, p.boxes - (waits ? 0 : 1))) });
    // Order by: the last order date, or earlier when this plan's cutoff would hold the box into the break.
    let by = dd.lastOrder;
    const B = dd.from && anchorAfter(addDays(dd.from, -1));
    // Monthly first boxes ship right away, so only the last order date applies to them.
    if (p.boxes > 1 && B && dd.to && B <= dd.to) { const b = addDays(B, -(cut + 1)); if (!by || b < by) by = b; }
    if (dd.noteFrom && by && t >= dd.noteFrom && t <= by && !late(t)) out.note = fill(+t === +by ? T.holidayToday : T.holidayNote, { date: day(by) });
    return out;
  }
  // Terms next to a button: a monthly order that ships now is charged again on the anchor, so the date goes there too.
  const termsFor = (p, k) => { const t = terms(p, k), fb = p.boxes === 1 ? firstBox(p) : null; return fb && fb.next ? t + ' Next charge: ' + fb.next + '.' : t; };

  /* Rendering */
  const els = {};
  ('byo byo-count consent sum-name sum-flavors sum-plan sum-ship sum-total sum-was sum-compare sum-save terms add-text alert status '
    + 'ccpotm-bar bar-label bar-plan bar-terms bar-btn inbox-bags lineups gift-terms gift-plan gift-plan-text').split(' ').forEach(k => { els[k.replace(/-(\w)/g, (m, c) => c.toUpperCase())] = el(k); });
  els.byoErr = $('[data-err="byo"]', root);
  els.counter = $('[data-counter="msg"]', root);
  // Change text only when it differs, so screen readers don't hear it twice.
  const setText = (x, text) => { if (x && x.textContent !== text) x.textContent = text; };
  // Live regions: empty, then fill a moment later, so a repeat is read again.
  const say = (x, text) => { if (!x) return; clearTimeout(x.ccSay); x.textContent = ''; if (text) x.ccSay = setTimeout(() => { x.textContent = text; }, 60); };
  // The terms, with "your account" linking to the member portal.
  const setTerms = (x, text) => {
    if (!x || x.dataset.t === text) return;
    x.dataset.t = text;
    const i = cfg.portal && cfg.acct ? text.indexOf(cfg.acct) : -1;
    if (i < 0) { x.textContent = text; return; }
    const a = document.createElement('a');
    a.href = cfg.portal;
    a.textContent = cfg.acct;
    x.replaceChildren(text.slice(0, i), a, text.slice(i + cfg.acct.length));
  };

  function bag(name) {
    const f = name ? flavorBy.get(name.toLowerCase()) : null;
    const box = document.createElement('span');
    const inner = document.createElement(f && f.image ? 'img' : 'span');
    box.className = 'ccpotm-bag' + (!name ? ' ccpotm-bag--slot' : f && f.image ? '' : ' ccpotm-bag--plain');
    if (f && f.image) { inner.src = f.image; inner.alt = ''; inner.loading = 'lazy'; } else inner.textContent = name || '+';
    box.append(inner);
    return box;
  }
  const bagsFor = pk => (pk.byo ? state.picks.concat(new Array(Math.max(0, slotsOf(pk) - state.picks.length)).fill('')) : pk.flavors);
  let inboxKey = pack() ? bagsFor(pack()).join('|') : '';
  let said = null, sayTimer = 0;
  function render() {
    const pk = pack(), p = plan(), slots = slotsOf(pk), done = byoDone(), plans = plansFor(state.variant), byo = !!(pk && pk.byo), gift = state.who === 'gift';
    // Plan cards: this variant's prices; a plan it lacks is hidden.
    $$('[data-plan-card]', form).forEach(card => {
      const a = plans.find(x => String(x.id) === card.dataset.planCard);
      card.hidden = !a;
      if (!a) return;
      setText($('[data-per]', card), fill(T.perBox, { price: money(a.per) }));
      setText($('[data-today]', card), fill(T.today, { price: money(a.price) }));
      setText($('[data-compare]', card), money(a.compare));
      setText($('[data-save]', card), fill(T.save, { amount: money(a.compare - a.price) }));
      setText($('[data-after]', card), afterText(a));
    });
    // A lineup, or pick your own.
    if (els.lineups) els.lineups.hidden = byo;
    const mode = $(`input[name="ccpotm_mode"][value="${byo ? 'byo' : 'lineup'}"]`, form);
    if (mode) mode.checked = true;
    if (els.byo) {
      els.byo.hidden = !byo;
      $$('[data-flavor]', els.byo).forEach(tile => {
        const n = state.picks.filter(x => x === tile.dataset.flavor).length;
        setText($('[data-byo-n]', tile), String(n));
        setText($('[data-byo-vh]', tile), fill(T.byoTile, { n }));
        tile.classList.toggle('is-picked', n > 0);
        $('[data-byo-minus]', tile).setAttribute('aria-disabled', String(n === 0));
        $('[data-byo-plus]', tile).setAttribute('aria-disabled', String(state.picks.length >= slots));
      });
      if (byo) { setText(els.byoCount, fill(T.byoCount, { n: state.picks.length, slots })); els.byoCount.classList.toggle('is-done', done); }
      if (done) { setText(els.byoErr, ''); els.byo.classList.remove('is-error'); }
    }
    root.dataset.who = state.who;
    // Summary, terms, button.
    const left = slots - state.picks.length;
    const pick = state.picks.length ? fill(T.buttonMore, { n: left, s: left === 1 ? '' : 's' }) : fill(T.buttonPick, { slots });
    setText(els.sumName, pk ? pk.name : '');
    setText(els.sumFlavors, !pk ? '' : byo ? (done ? picksText() : pick) : pk.flavors.join(', '));
    if (p) {
      const save = p.boxes > 1 && p.compare > p.price;
      const fb = firstBox(p);
      const parts = fb.lines.map(t => [t, '']).concat(fb.note ? [[fb.note, 'ccpotm-sum__note']] : []);
      if (els.sumShip && parts.join('|') !== Array.from(els.sumShip.children, s => [s.textContent, s.className]).join('|')) {
        els.sumShip.replaceChildren(...parts.map(([t, c]) => { const s = document.createElement('span'); s.textContent = t; if (c) s.className = c; return s; }));
      }
      setText(els.sumPlan, sumPlan(p));
      setText(els.sumTotal, fill(T.sumToday, { price: money(p.price) }));
      els.sumWas.hidden = els.sumSave.hidden = !save;
      if (save) { setText(els.sumCompare, money(p.compare)); setText(els.sumSave, fill(T.sumSave, { amount: money(p.compare - p.price) })); }
      setTerms(els.terms, termsFor(p, 'terms'));
      setText(els.giftTerms, terms(p, 'gift'));
      if (els.giftPlan) { els.giftPlan.hidden = !(state.giftSet && gift); setText(els.giftPlanText, fill(T.giftPlan, { plan: planLabel(p) })); }
    }
    setText(els.addText, done ? fill(gift ? T.buttonGift : T.button, { price: p ? money(p.price) : '' }) : pick);
    addBtn.classList.toggle('is-incomplete', !done);
    // Sticky bar: the pick, the plan and price, its button, and the plan's full terms (how to cancel too).
    setText(els.barLabel, pk ? pk.name : '');
    setText(els.barPlan, p ? planLabel(p) + ' \u00b7 ' + money(p.price) : '');
    setTerms(els.barTerms, p ? termsFor(p, 'terms') : '');
    setText(els.barBtn, done ? (gift ? T.barGift : T.bar) : pick);
    els.barBtn.classList.toggle('is-off', !done);
    // What's in every box.
    const names = pk ? bagsFor(pk) : [];
    if (els.inboxBags && names.join('|') !== inboxKey) { inboxKey = names.join('|'); els.inboxBags.replaceChildren(...names.map(bag)); }
    // Screen readers: one short line once a choice settles (each radio already reads its own card).
    const now = pk && p ? [pk.name, planLabel(p), fill(T.sumToday, { price: money(p.price) })].join(', ') : '';
    if (said === null) said = now;
    else if (now !== said) { said = now; clearTimeout(sayTimer); sayTimer = setTimeout(() => say(els.status, now), 500); }
  }

  /* Choices */
  const checkPlan = id => { state.plan = id; const r = $(`input[name="selling_plan"][value="${id}"]`, form); if (r) r.checked = true; };
  function setVariant(vid, user) {
    const was = plan();
    state.variant = vid;
    if (pack() && !pack().byo) lastLineup = vid;
    const r = $(`input[name="id"][value="${vid}"]`, form);
    if (r) r.checked = true;
    if (!plan()) { const alt = (was && planByBoxes(was.boxes)) || plansFor(vid)[0]; if (alt) checkPlan(alt.id); }
    if (user) { customize(); track('potm_pack_select', { pack: pack() ? pack().name : '', variant_id: vid }); }
    render();
  }
  function setWho(who, user) {
    state.who = who === 'gift' ? 'gift' : 'me';
    const r = $(`input[name="ccpotm_who"][value="${state.who}"]`, form);
    if (r) r.checked = true;
    // Month to month for me, the gift default for a gift, unless they picked a plan; the gift note says when it moved.
    state.giftSet = false;
    if (!state.planPicked) {
      const p = planByBoxes(state.who === 'gift' ? parseInt(cfg.giftPlan, 10) || 1 : 1);
      if (p) { state.giftSet = state.who === 'gift' && p.id !== state.plan; checkPlan(p.id); }
    }
    if (user && state.who === 'gift') track('potm_gift_on', {});
    render();
  }
  on(form, 'change', e => {
    const t = e.target;
    if (t.name === 'id') setVariant(+t.value, true);
    else if (t.name === 'ccpotm_mode') setVariant(t.value === 'byo' && byoPack ? byoPack.variant : lastLineup, true);
    else if (t.name === 'ccpotm_who') setWho(t.value, true);
    else if (t.name === 'selling_plan') {
      state.plan = +t.value;
      state.planPicked = true;
      state.giftSet = false;
      const p = plan();
      if (p) { customize(); track('potm_plan_select', { plan: planKey(p), boxes: p.boxes, value: p.price / 100, per_box: p.per / 100 }); }
      render();
    } else if (t.matches('[data-consent]')) clearErr('consent');
  });
  on(form, 'input', e => {
    const f = e.target.dataset ? e.target.dataset.field : '';
    if (!f) return;
    clearErr(f);
    if (f === 'msg') setText(els.counter, e.target.value.length + ' / ' + e.target.maxLength);
  });
  on(form, 'click', e => {
    if (e.target.closest('[data-to-plans]')) {
      scrollTo($('[data-step="plan"]', form), 'start');
      const r = $('input[name="selling_plan"]:checked', form);
      if (r) r.focus({ preventScroll: true });
      return;
    }
    const b = e.target.closest('[data-byo-plus], [data-byo-minus], [data-byo-clear]');
    if (!b) return;
    const wasDone = byoDone();
    let full = false;
    if (b.hasAttribute('data-byo-clear')) state.picks = [];
    else if (b.getAttribute('aria-disabled') !== 'true') {
      const name = b.closest('[data-flavor]').dataset.flavor;
      if (b.hasAttribute('data-byo-plus')) state.picks.push(name);
      else { const i = state.picks.lastIndexOf(name); if (i >= 0) state.picks.splice(i, 1); }
    } else full = b.hasAttribute('data-byo-plus');
    render();
    if (full) setText(els.byoCount, T.byoFull);
    if (!wasDone && byoDone()) track('potm_byo_complete', { flavors: state.picks.join(', ') });
  });
  // Enter picks a radio or ticks a box, and does nothing in a text field: it never adds to the cart.
  on(form, 'keydown', e => {
    const t = e.target;
    if (e.key !== 'Enter' || !t.matches('input')) return;
    if (t.matches('[type="radio"], [type="checkbox"]')) { e.preventDefault(); if (!t.checked) t.click(); } else if (t.type === 'text') e.preventDefault();
  });
  on(form, 'submit', e => { e.preventDefault(); add(); });
  on(els.barBtn, 'click', () => add());
  // "Giving it as a gift? Start here" under the price line: gift mode and its step, no reload. A new-tab click, or
  // a page with no gift step, follows the link (?gift=1 opens gift mode on load).
  on(el('gift-start'), 'click', e => {
    const r = $('input[name="ccpotm_who"][value="gift"]', form);
    if (!cfg.gift || !r || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (state.who !== 'gift') { setWho('gift'); track('potm_gift_on', { entry: 'top_link' }); }
    scrollTo($('[data-step="who"]', form), 'start');
    r.focus({ preventScroll: true });
  });

  /* Checks before the add */
  const PRINTABLE = /[^\x00-\u024f\u2010-\u2027\u2030-\u2044\u20ac\u2122\s]/u;
  function check() {
    const pk = pack(), p = plan(), v = pk && variants.get(pk.variant);
    if (!pk || !v || !v.available) return { reason: 'pack', msg: T.errPack };
    if (!p) return { reason: 'plan', msg: T.errPlan };
    if (pk.byo && !byoDone()) return { reason: 'byo_incomplete', field: 'byo', msg: fill(T.byoMissing, { slots: slotsOf(pk) }) };
    for (const f of (state.who === 'gift' ? ['to', 'from', 'msg'] : []).concat(['allergy'])) {
      const x = field(f);
      if (!x) continue;
      if (x.maxLength > 0 && x.value.length > x.maxLength) return { reason: 'too_long_' + f, field: f, msg: fill(T.errLong, { n: x.value.length - x.maxLength }) };
      if (f !== 'allergy' && PRINTABLE.test(x.value)) return { reason: 'emoji_' + f, field: f, msg: T.errEmoji };
    }
    if (cfg.consent && els.consent && !els.consent.checked) return { reason: 'consent', field: 'consent', msg: T.errConsent };
    return null;
  }
  const fieldOf = f => (f === 'consent' ? els.consent : field(f));
  function clearErr(f) {
    const x = fieldOf(f);
    if (x) x.removeAttribute('aria-invalid');
    setText($(`[data-err="${f}"]`, root), '');
  }
  function blocked(c) {
    track('potm_blocked', { reason: c.reason.slice(0, 90) });
    if (c.field === 'byo') {
      say(els.byoErr, c.msg);
      els.byo.classList.add('is-error');
      scrollTo(els.byo, 'start'); // its counter and the message sit at the top
      const b = $('[data-byo-plus]:not([aria-disabled="true"])', els.byo);
      if (b) b.focus({ preventScroll: true });
      return;
    }
    const x = c.field ? fieldOf(c.field) : null;
    if (!x) { showAlert(c.msg); return; }
    setText($(`[data-err="${c.field}"]`, root), c.msg);
    x.setAttribute('aria-invalid', 'true');
    if (x.closest('details')) x.closest('details').open = true;
    scrollTo(x);
    x.focus({ preventScroll: true });
  }
  const showAlert = (text, isInfo) => { say(els.alert, text || ''); els.alert.classList.toggle('is-info', !!isInfo); };

  /* The add: one line, quantity 1, the selling plan, line item properties */
  function properties(pk, p, fb, gift) {
    const o = {};
    if (gift) [['to', 'Gift for'], ['from', 'Gift from'], ['msg', 'Gift message']].forEach(([f, name]) => { if (val(f)) o[name] = val(f); });
    if (pk.byo) state.picks.forEach((f, i) => { o['Flavor ' + (i + 1)] = f; });
    if (val('allergy')) o['Allergy note'] = val('allergy');
    // Underscore: hidden in the cart, kept on the order. Seal copies properties onto every renewal order, so
    // the first box date is hidden.
    o._first_box = fb.prop;
    o._potm_source = 'potm page v1';
    if (gift) o._potm_for = 'gift';
    o._potm_plan = [planLabel(p), fill(T.perBox, { price: money(p.per) }), fill(T.sumToday, { price: money(p.price) }),
      ends(p) ? `ends after ${p.boxes} boxes` : 'renews at ' + money(p.renew)].join(', ');
    o._potm_terms = termsFor(p, 'terms');
    if (cfg.bonus) o._potm_bonus = 'yes';
    if (cfg.consent) o._potm_consent = 'yes, ' + new Date().toISOString();
    if (cfg.test) o._test = 'TEST';
    return o;
  }
  const working = isOn => { addBtn.classList.toggle('working', isOn); addBtn.setAttribute('aria-busy', String(isOn)); };
  // Who a club line is for: 'me', or 'gift:' and their first name ('gift:' alone when the gift has no name).
  const props = i => i.properties || {};
  const personOf = pr => (pr._potm_for === 'gift' || pr['Gift for'] || pr['Gift from'] || pr['Gift message'] ? 'gift:' + String(pr['Gift for'] || '').trim().toLowerCase() : 'me');
  const personText = pr => (personOf(pr) === 'me' ? T.forMe : pr['Gift for'] ? fill(T.forGift, { name: pr['Gift for'] }) : T.forGiftNoName);
  // A cart line as /cart/add.js takes it, to put it back if the add fails.
  const asItem = i => ({ id: i.variant_id || i.id, quantity: i.quantity, selling_plan: i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : undefined, properties: props(i) });
  let busy = false;
  const shipOk = new Set(); // gifts the shopper said may ship with the other items in the cart
  async function add() {
    if (busy) return;
    showAlert('');
    const c = check();
    if (c) { blocked(c); return; }
    busy = true;
    working(true);
    const pk = pack(), p = plan(), gift = state.who === 'gift', to = val('to');
    const who = gift ? 'gift:' + to.toLowerCase() : 'me';
    const item = { id: pk.variant, quantity: 1, selling_plan: p.id, properties: properties(pk, p, firstBox(p), gift) };
    let removed = [];
    try {
      const cart = await fetch(route('cart.js'), { headers: { Accept: 'application/json' } }).then(r => (r.ok ? r.json() : null)).catch(() => null);
      const items = (cart && cart.items) || [];
      // Club lines already in the cart, from any tab: one for the same person is replaced (a double tap, a change
      // of mind). One checkout ships to one address, so a club for anyone else (or a gift with no name) is a question.
      const clubs = items.filter(i => i.product_id === cfg.productId);
      const same = clubs.filter(i => who !== 'gift:' && personOf(props(i)) === who);
      const others = clubs.filter(i => same.indexOf(i) < 0);
      if (others.length) {
        working(false);
        const other = list(Array.from(new Set(others.map(i => personText(props(i))))));
        // Replacing takes something out of the cart, so the safe answer is the default here.
        if (!(await ask(T.clubTitle, fill(T.clubText, { other }), fill(T.clubYes, { it: others.length > 1 ? 'them' : 'it', other }), T.clubNo, true))) { showAlert(T.clubLater, true); return; }
        working(true);
      }
      // A gift ships to them, so ask (once per person) before the other items in the cart go there too.
      if (gift && !shipOk.has(who) && items.some(i => i.product_id !== cfg.productId)) {
        working(false);
        if (!(await ask(T.askTitle, T.askText, fill(T.askYes, { name: to || 'them' }), T.askNo))) { showAlert(T.askLater, true); return; }
        shipOk.add(who);
        working(true);
      }
      // Take the old club lines out first. If one won't come out, stop rather than double up.
      for (const i of same.concat(others)) {
        const rm = await post('cart/change.js', { id: i.key, quantity: 0 }).catch(() => null);
        if (!rm || !rm.ok) throw new Error('remove ' + (rm ? rm.status : 'network'));
        removed.push(asItem(i));
      }
      const r = await post('cart/add.js', { items: [item] });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) { const er = new Error(String(j.description || j.message || r.status)); er.shown = typeof j.description === 'string' ? j.description : ''; throw er; }
      const swapped = removed.length > 0;
      removed = [];
      const ev = { value: p.price / 100, currency: 'USD', pack: pk.name, plan: planKey(p) };
      track('potm_add', Object.assign({}, ev, { gift, byo: !!pk.byo }));
      // The gift card page (gift_card_url) fills its form from this, on this device only, for 14 days.
      if (gift) { try { localStorage.setItem('ccpotm_gift', JSON.stringify({ to: val('to'), from: val('from'), msg: val('msg'), plan: p.boxes, t: Date.now() })); } catch (e) { /* storage off: the card page starts empty */ } }
      meta('trackCustom', 'POTMAdd', ev);
      document.dispatchEvent(new CustomEvent('krown:cart:add', { bubbles: true, detail: { productForm: form, variantId: String(pk.variant) } }));
      const msg = fill(same.length && !gift ? T.replacedMe : T.replaced, { email: cfg.email });
      say(els.status, swapped ? msg : T.added);
      if (swapped) showAlert(msg, true);
      if (cfg.afterAdd === 'checkout') location.href = route('checkout');
      else if (typeof window.refreshCart === 'function') Promise.resolve().then(() => window.refreshCart(true)).catch(() => { location.href = route('cart'); });
      else location.href = route('cart');
    } catch (err) {
      console.error('[ccpotm] add to cart', err);
      track('potm_add_error', { message: String((err && err.message) || err).slice(0, 90) });
      showAlert(((err && err.shown) || T.errAdd) + ' ' + fill(T.errRetry, { email: cfg.email }));
      // The add failed after old lines came out: put them back as they were.
      if (removed.length) await post('cart/add.js', { items: removed }).catch(() => null);
    } finally {
      busy = false;
      working(false);
    }
  }
  // A question with two answers, in a native modal dialog (the page behind it is inert; Escape answers no).
  // safeFirst: "no" is the solid, first-focused button (for answers that remove something).
  function ask(title, text, yesText, noText, safeFirst) {
    return new Promise(resolve => {
      const box = el('ask'), yes = el('ask-yes'), no = el('ask-no'), back = document.activeElement;
      yes.classList.toggle('ccpotm-btn2--solid', !safeFirst);
      no.classList.toggle('ccpotm-btn2--solid', !!safeFirst);
      let over = false;
      const done = answer => {
        if (over) return;
        over = true;
        box.onclose = null;
        if (box.open) { if (box.close) box.close(); else box.removeAttribute('open'); }
        if (back && back.focus) back.focus({ preventScroll: true });
        resolve(answer);
      };
      setText(el('ask-h'), title);
      setText(el('ask-text'), text);
      yes.textContent = yesText;
      no.textContent = noText;
      yes.onclick = () => done(true);
      no.onclick = () => done(false);
      // The close event from an earlier question can arrive after this one opens: only a real close counts.
      box.onclose = () => { if (!box.open) done(false); };
      if (box.showModal) box.showModal(); else box.setAttribute('open', '');
      (safeFirst ? no : yes).focus();
    });
  }

  /* Analytics: potm_* only (the apps send add_to_cart themselves) */
  function track(event, params) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event }, params)); } catch (e) { /* no dataLayer */ }
    if (quiet) return;
    try {
      // GA4 IDs only, not the Ads tags.
      const ids = window.dataLayer.filter(x => x && x[0] === 'config' && /^G-[A-Z0-9]+$/.test(String(x[1]))).map(x => String(x[1]));
      if (typeof window.gtag === 'function') window.gtag('event', event, ids.length ? Object.assign({ send_to: Array.from(new Set(ids)) }, params) : params);
    } catch (e) { /* no gtag */ }
    try { const a = window.Shopify && window.Shopify.analytics; if (a && typeof a.publish === 'function') a.publish(event, params); } catch (e) { /* none */ }
  }
  function meta(kind, name, params) {
    if (quiet || typeof window.fbq !== 'function') return;
    try { if (params) window.fbq(kind, name, params); else window.fbq(kind, name); } catch (e) { /* no pixel */ }
  }
  let customized = false;
  const customize = () => { if (!customized) { customized = true; meta('track', 'CustomizeProduct'); } };

  /* Sticky bar, at any width: past the top of the buy box with the main button out of view */
  const bar = els.ccpotmBar;
  let btnSeen = true, footSeen = false, viewSent = false, raf = 0;
  const drawer = () => document.getElementById('site-cart-sidebar') || $('[data-js-site-cart-sidebar]');
  const drawerOpen = () => { const d = drawer(); return !!d && (d.classList.contains('sidebar--opened') || d.hasAttribute('open')); };
  function updateBar() {
    // Hidden while a keyboard user is in the form, so it never covers what has focus.
    const a = document.activeElement;
    let kb = false;
    try { kb = form.contains(a) && a !== addBtn && a.matches(':focus-visible'); } catch (e) { /* no :focus-visible */ }
    const show = !btnSeen && !footSeen && !kb && !drawerOpen() && form.getBoundingClientRect().top < 0;
    if (bar.classList.contains('is-on') === show) return;
    if (!show && bar.contains(a)) addBtn.focus({ preventScroll: true });
    bar.classList.toggle('is-on', show);
    bar.setAttribute('aria-hidden', String(!show));
    els.barBtn.tabIndex = show ? 0 : -1;
    document.body.classList.toggle('ccpotm-bar-on', show);
    html.style.scrollPaddingBottom = show ? bar.offsetHeight + 8 + 'px' : '';
    if (show) html.style.setProperty('--ccpotm-bar-h', bar.offsetHeight + 'px');
  }
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; updateBar(); }); };
  on(window, 'scroll', onScroll, { passive: true });
  on(window, 'resize', onScroll);
  on(form, 'focusin', onScroll);
  on(form, 'focusout', onScroll);
  if (drawer()) watch(drawer(), updateBar, { attributes: true, attributeFilter: ['class', 'open', 'style'] });
  if ('IntersectionObserver' in window) {
    const foot = $('.shopify-section-group-footer-group, .main-footer, footer');
    const seen = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.target === addBtn) btnSeen = en.isIntersecting; else footSeen = en.isIntersecting; });
      updateBar();
    });
    seen.observe(addBtn);
    if (foot) seen.observe(foot);
    // potm_view, once: half the buy box (or half a screen of it) in view.
    const view = new IntersectionObserver(entries => entries.forEach(en => {
      if (viewSent || !(en.intersectionRatio >= 0.5 || en.intersectionRect.height >= window.innerHeight * 0.5)) return;
      viewSent = true;
      view.disconnect();
      track('potm_view', { pack: pack() ? pack().name : '', plan: plan() ? planKey(plan()) : '' });
    }), { threshold: [0, 0.25, 0.5] });
    view.observe(form);
    offs.push(() => { seen.disconnect(); view.disconnect(); });
  }

  /* Start: links like ?plan=6 or ?gift=1, the first render, then (only once all of that worked) Pick your own on,
     and the form handed over to this script. */
  const q = new URLSearchParams(location.search);
  if (q.get('selling_plan') && plan()) state.planPicked = true;
  const qPlan = (q.get('plan') || '').toLowerCase();
  if (qPlan) { const p = planByBoxes(qPlan === 'monthly' ? 1 : parseInt(qPlan, 10)); if (p) { checkPlan(p.id); state.planPicked = true; } }
  if (!plan()) { const p = planByBoxes(1) || plansFor(state.variant)[0]; if (p) checkPlan(p.id); }
  if (field('msg')) setText(els.counter, field('msg').value.length + ' / ' + field('msg').maxLength);
  if (cfg.gift && (state.who === 'gift' || /^(1|true|yes)$/i.test(q.get('gift') || ''))) setWho('gift'); else render();
  $$('[data-byo-on]', form).forEach(x => { x.disabled = false; });
  // Seal, layer 2: with every handler in place, take the action off so Seal's form scan finds nothing here.
  form.noValidate = true;
  if (form.hasAttribute('action')) { form.dataset.ccpotmAction = form.getAttribute('action'); form.removeAttribute('action'); }
  root.setAttribute('data-ccpotm-ready', '');

  return {
    render, state, firstBox,
    destroy() {
      offs.forEach(off => off());
      if (raf) cancelAnimationFrame(raf);
      clearTimeout(sayTimer);
      const box = el('ask');
      if (box && box.open && box.close) box.close();
      document.body.classList.remove('ccpotm-bar-on');
      html.style.scrollPaddingBottom = '';
      root.removeAttribute('data-ccpotm-ready');
    }
  };
}
})();
